import { RowDataOrder } from "../../components/OrderPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the OrderTable factory
 */
class OrderRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/orders/read-range"
        this.accessData = "orders"
    }

    create(order: any): RowDataOrder {
        const rowDataOrder: RowDataOrder = {
            uid: order.uid,
            order_id: order.order_id,
            p_transaction_id: order.p_transaction_id,
            tracking_number: order.tracking_number,
            courier_service: order.courier_service,
            merch_name: order.merch_name,
            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current === "current"
        return params
    }
}

let orderRow: OrderRow | null = null;

export default function getOrderRow(): OrderRow {
    if (orderRow === null)
        orderRow = new OrderRow()
    return orderRow
}